module.exports = __webpack_public_path__ + "img/en.b32afdad.png";